@switch (field.type) {
    @case ('icon') {
        <app-icon-table-cell [field]="$any(field)" [focusItem]="focusItem"></app-icon-table-cell>
    }
    @case ('link') {
        <div [style]="field.tableStyle(focusItem)">
            <app-link-table-cell [field]="$any(field)" [focusItem]="focusItem"></app-link-table-cell>
        </div>
    }
    @case ('picklist') {
        <div [style]="field.tableStyle(focusItem)">
            <app-picklist-table-cell [field]="$any(field)" [focusItem]="focusItem"></app-picklist-table-cell>
        </div>
    }
    @case ('dateTime') {
        <div [style]="field.tableStyle(focusItem)">
            <app-date-time-table-cell [field]="$any(field)" [focusItem]="focusItem"></app-date-time-table-cell>
        </div>
    }
    @case ('longText') {
        <div [matTooltip]="field.getValue(focusItem)"  [style]="field.tableStyle(focusItem)">
            {{field.getFormattedValue(focusItem) | limitTo:field.maxLength ? field.maxLength : 150}}
        </div>
    }
    @case ('boolean') {
        <div [style]="field.tableStyle(focusItem)">
            @if (field.getValue(focusItem)) {
              <mat-icon color="primary">done</mat-icon>
            }
        </div>
    }
    @case ('email') {
        <div [style]="field.tableStyle(focusItem)">
            {{field.getFormattedValue(focusItem)}}
        </div>
    }
    @case ('url') {
        <div [style]="field.tableStyle(focusItem)">
            <a [href]="field.getFormattedValue(focusItem)"
            target="_blank">{{field.getFormattedValue(focusItem)}}</a>
        </div>
    }
    @case ('pickLink') {
        <app-pick-link-table-cell [focusItem]="focusItem" [field]="$any(field)"></app-pick-link-table-cell>
    }
    @case ('pill') {
        <app-form-pill on="grid" [field]="$any(field)" [item]="focusItem"
            (clicked)="pillClicked($any(field), focusItem)"></app-form-pill>
    }
    @default {
        <div [style]="field.tableStyle(focusItem)">
            {{field.getFormattedValue(focusItem)}}
        </div>
    }
}
